import React from 'react';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Features } from '../components/Features';
import { SailingTracker } from '../components/SailingTracker';
import { Rules } from '../components/Rules';
import { Organization } from '../components/Organization';
import { Pricing } from '../components/Pricing';
import { AtmosphereStrip } from '../components/AtmosphereStrip';
import { Gallery } from '../components/Gallery';
import { CTA } from '../components/CTA';
export function Home() {
  return <main data-id="element-300" data-mp="24hk6xchgnhkb">
      <Hero data-id="element-301" data-mp="24haezjcuv0bz" />
      <About data-id="element-302" data-mp="24ivb3detirby" />
      <Features data-id="element-303" data-mp="29gdbugiom08v" />
      <SailingTracker data-id="element-304" data-mp="29flotu35hau7" />
      <Rules data-id="element-305" data-mp="29fc1ke9hphs7" />
      <Organization data-id="element-306" data-mp="29etusnp7bl61" />
      <Pricing data-id="element-307" data-mp="29ihq9se7ihne" />
      <AtmosphereStrip data-id="element-308" data-mp="2dhgrp30qbwa3" />
      <Gallery data-id="element-309" data-mp="2dhyukihwd8qz" />
      <CTA data-id="element-310" data-mp="2dii1z59x8eqr" />
    </main>;
}